import { motion } from "framer-motion";
import { TRIMS } from "../config";

const Card = ({ trim, i }) => (
  <motion.article
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
    className="group relative"
    data-testid={`trim-card-${trim.code.toLowerCase().replace(/\s+/g, "-")}`}
  >
    <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] border border-white/10 bg-[#2A1A0E]">
      <img
        src={`${process.env.REACT_APP_BACKEND_URL}${trim.image}`}
        alt={`${trim.name} trim samples`}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      <span className="absolute top-5 left-5 text-[10px] tracking-[0.25em] uppercase font-bold text-white/70">
        {String(i + 1).padStart(2, "0")}
      </span>
      <span className="absolute top-5 right-5 rounded-full bg-white/10 backdrop-blur px-3 py-1 text-xs text-white border border-white/15">
        {trim.type}
      </span>
      <div className="absolute inset-x-5 bottom-5">
        <h4 className="text-xl font-semibold text-white font-heading tracking-tight">{trim.name}</h4>
        <p className="text-xs uppercase tracking-[0.2em] text-[#E8B57F] mt-1">{trim.code}</p>
      </div>
      <span className="pointer-events-none absolute inset-0 rounded-[24px] ring-1 ring-inset ring-[#E8B57F]/0 transition-[box-shadow,ring-color] duration-500 group-hover:ring-[#E8B57F]/60" />
    </div>
    <p className="mt-5 text-sm text-white/70 leading-relaxed">{trim.use}</p>
    <p className="mt-3 text-xs text-white/50">
      <span className="font-semibold text-white/70">Finishes:</span> {trim.finishes}
    </p>
  </motion.article>
);

export const TrimCards = () => (
  <div data-testid="trims-section">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6 lg:gap-8">
      {TRIMS.map((t, i) => (
        <Card key={t.code} trim={t} i={i} />
      ))}
    </div>
  </div>
);
